module.exports = __webpack_public_path__ + "media/device_images/iphone-roster-profile-db69a52b.svg";